export const DEFAULT_EXTERNAL_COST_PER_HOUR = 100;
export const DEFAULT_MIN_ATTENDEES = 3;

export const getOrganizationSettingsState = (organization) => {
  const storedMinAttendees = organization?.settings?.minAttendees || 0;

  return {
    costAnonymityEnabled: storedMinAttendees > 0,
    minAttendees:
      storedMinAttendees > 0 ? storedMinAttendees : DEFAULT_MIN_ATTENDEES,
    allowVideoRecording:
      organization?.settings?.allowVideoRecording !== false,
    externalCostPerHour:
      organization?.external_attendees_cost_per_hour ??
      DEFAULT_EXTERNAL_COST_PER_HOUR,
  };
};

export const buildOrganizationSettingsUpdate = ({
  costAnonymityEnabled,
  minAttendees,
  allowVideoRecording,
  externalCostPerHour,
}) => ({
  "settings.minAttendees": costAnonymityEnabled ? minAttendees : 0,
  "settings.allowVideoRecording": allowVideoRecording,
  external_attendees_cost_per_hour:
    externalCostPerHour || DEFAULT_EXTERNAL_COST_PER_HOUR,
});
